import moment from 'moment'
import * as Sentry from '@sentry/browser'
import posthog from 'posthog-js'
import { setupFirebase } from './services/firebase'

const { REACT_APP_API_ENV, REACT_APP_POSTHOG_KEY } = process.env
const storageName = process.env.FEGUARANTOR_NAME

// sentry active only production.
Sentry.init({
  dsn: 'https://2e11c55aa59344f8885a333dc05c0d80@sentry.io/1868741',
  environment: REACT_APP_API_ENV,
  beforeBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'ui.click' || breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch'
      ? null
      : breadcrumb
  }
})

if (REACT_APP_POSTHOG_KEY) {
  posthog.init(REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: true
  })
}

// initial setup firebase
setupFirebase()

moment.updateLocale('pt-br', require('moment/locale/pt-br'))
